import { loadScript, removeScripts } from 'common-utils';

import { Events } from '../tracking-events/event';
import { TrackEvent, TrackingTool } from '../tracking-tool';
import { TrackingProperties } from '../use-tracking';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer: any;
    gtag: (
      type: 'event',
      action: string,
      config: { [key: string]: number | string | boolean | null | undefined },
    ) => void;
  }
}

export class GoogleAnalytics4 implements TrackingTool {
  private readonly _gtmId: string;
  private readonly _ga4Id: string;

  constructor(ga4Id: string, gtmId: string) {
    this._ga4Id = ga4Id;
    this._gtmId = gtmId;
  }

  async trackCommonEvent(event: Events, properties?: TrackingProperties) {
    const { type, ...data } = event;
    if (type !== 'click-to-track-paperpal') {
      return;
    }
    const expandedQueries: { [key: string]: string } = {};
    let otherProperties: Omit<TrackingProperties, 'query'> = {};
    if (properties) {
      const { query, disableGa4Tracking, ...splitProperties } = properties;
      otherProperties = splitProperties;
      for (const key in query) {
        const value = query[key];
        if (value) {
          expandedQueries[`query_${key}`] = value;
        }
      }
    }

    const eventProperties = {
      ...data,
      ...otherProperties,
      ...expandedQueries,
    };
    window.gtag?.('event', type, eventProperties);
  }

  public turnOn = async () => {
    await loadScript(
      `https://www.googletagmanager.com/gtag/js?id=${this._ga4Id}`,
    );
    await loadScript(
      `https://www.googletagmanager.com/gtm.js?id=${this._gtmId}`,
    );
    window.dataLayer = window.dataLayer || [];

    function gtag() {
      //@ts-ignore
      window.dataLayer.push(arguments);
    }

    window.gtag = window.gtag || gtag;
    //@ts-ignore
    gtag('js', new Date());
    //@ts-ignore
    gtag('config', this._ga4Id);
    //@ts-ignore
    gtag('config', this._gtmId);

    addGTMNoScript(this._gtmId);
  };

  public turnOff = async () => {
    removeScripts([
      `https://www.googletagmanager.com/gtag/js?id=${this._ga4Id} , https://www.googletagmanager.com/gtm.js?id=${this._gtmId}}`,
    ]);
  };
  public getName = () => {
    return 'ga4';
  };
  public trackEvent = async ({ action, category, label }: TrackEvent) => {
    window.gtag?.('event', action, {
      event_category: category,
      event_label: label,
    });
  };
}

function addGTMNoScript(gtmId: string) {
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  const noscript = document.createElement('noscript');
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}
